import { ApiResponse, Clinic, PaginationResponse } from '@magnetar/admin-api-interfaces'
import { useAuth } from './useAuth'
import { useGet } from './useFetch'

export function useAllClinics() {
  const { token } = useAuth()
  const { data, error, mutate } = useGet<ApiResponse<PaginationResponse<Clinic>>>(
    token ? `/api/clinics?pageSize=1000` : null,
    undefined,
    token ?? '',
  )

  return {
    clinics: data?.data?.items || [],
    total: data?.data?.total || 0,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
